import { FILTER_DATA, ERROR } from 'src/store/localStorageKeys'
import * as actions from './actions'
import getters from './getters'
import mutations from './mutations'
import CONST from 'src/config/const'

const state = {
  notification: {
    title: '',
    message: '',
    type: '',
  },
  errors: {
    data: {},
  },
  isProcessing: false,
  isProcessingForm: false,
  isProcessingTable: false,
  isProcessingList: false,
  isProcessingSection: false,
  isProcessingCart: false,
  isProcessingValidation: false,
  isProcessingCrossValidation: false,
  isProcessingRedirect: false,
  openCloseModalForm: {
    modalData: [],
  },
  currentUpdateId: '',
  userTypes: {
    data: {
      options: [],
    },
  },
  simplePagination: {
    currentPage: 1,
    limit: 10,
    offset: 0,
    search: '',
  },
  formData: {},
  countriesOptions: {
    data: {
      options: [],
    },
  },
  allCountriesOptions: {
    data: {
      options: [],
    },
  },
  countriesCallCodeOptions: {
    data: {
      options: [],
    },
  },
  countriesCallCodeByCountryNameOptions: {
    data: {
      options: [],
    },
  },
  categoriesOptions: {
    data: {
      options: [],
    },
  },
  masterData: {
    data: {
      list: [],
    },
  },
  languagesOptions: {
    data: {
      options: [],
    },
  },
  appSettings: {
    mainLoadingDebounceDelay: 900,
    mainLoadingProcessDebounceDelay: 500,
    debounceDelay: 650,
    alertTimeout: 4500,
    shortcuts: [
      {
        module: 'General',
        items: [
          {
            name: 'Save / Create / Update',
            desc: 'Save operation without closing current page',
            shortcut: 'ctrl + alt + s',
          },
          {
            name: 'Save & Close',
            desc: 'Save operation success close current page and redirect to listing page',
            shortcut: 'ctrl + alt + q',
          },
          {
            name: 'Cancel',
            desc: 'Cancel operation close current page and redirect to listing page',
            shortcut: 'ctrl + alt + c',
          },
          {
            name: 'Delete',
            desc: 'Delete operation delete record',
            shortcut: 'ctrl + alt + d',
          },
          {
            name: 'Add',
            desc: 'Open Add item screen in all modules',
            shortcut: 'ctrl + alt + a',
          },
        ],
      },
    ],
    placement: {
      levels: [
        {
          label: '5 Levels',
          value: 5,
        },
        {
          label: '10 Levels',
          value: 10,
        },
        {
          label: '15 levels',
          value: 15,
        },
        {
          label: '20 levels',
          value: 20,
        },
      ],
    },
    sponsor: {
      levels: [
        {
          label: '5 Levels',
          value: 5,
        },
        {
          label: '10 Levels',
          value: 10,
        },
        {
          label: '15 levels',
          value: 15,
        },
        {
          label: '20 levels',
          value: 20,
        },
        {
          label: 'All levels',
          value: 100,
        },
      ],
    },
    fallback: {
      table_rows_per_page: 10,
    },
    defaulted: {
      table_color: 'primary-darkened',
      table_rows_per_page_options: [5, 10, 15, 20, 25, 50, 100],
      table_separators: {
        options: [
          { label: 'Horizontal', value: 'horizontal' },
          { label: 'Vertical', value: 'vertical' },
          { label: 'Cell', value: 'cell' },
          { label: 'None', value: 'none' },
        ],
        selection: 'horizontal',
      },
      date_format: 'DD-MM-YYYY',
      date_time_format: 'DD-MM-YYYY HH:mm:ss',
      date_time_zone_format: 'DD-MM-YYYY HH:mm:ss Z',
      date_time_format_without_secs: 'YYYY-MM-DD HH:mm',
    },
    tables: {
      products: {
        table_rows_per_page: 10,
      },
      kittings: {
        table_rows_per_page: 10,
      },
      modules: {
        table_rows_per_page: 10,
      },
      sales: {
        table_rows_per_page: 25,
      },
      pwp: {
        table_rows_per_page: 10,
      },
      users: {
        table_rows_per_page: 15,
      },
      evoucher: {
        table_rows_per_page: 15,
      },
      members_sales_history: {
        table_rows_per_page: 10,
      },
      report_config: {
        table_rows_per_page: 10,
      },
      membership_role: {
        table_rows_per_page: 10,
      },
      roles: {
        table_rows_per_page: 10,
      },
      role_groups: {
        table_rows_per_page: 10,
      },
      general_receipts: {
        table_rows_per_page: 10,
      },
      sales_transfer: {
        table_rows_per_page: 20,
      },
      sv_month_amendment: {
        table_rows_per_page: 20,
      },
      sv_transfer_by_product: {
        table_rows_per_page: 20,
      },
      member_bonus_adjustment: {
        table_rows_per_page: 20,
      },
      itoken_voucher: {
        table_rows_per_page: 20,
      },
      itoken_redemption: {
        table_rows_per_page: 20,
      },
      itoken_accumulate_calculation: {
        table_rows_per_page: 20,
      },
      sv_downline_listing: {
        table_rows_per_page: 25,
      },
    },
    notifications: {
      timeout: 6000,
    },
    report: {
      dailySalesReport: {
        userTypeId: 2,
      },
      cvAllocation: {
        types: [
          {
            value: 1,
            label: 'Rental',
          },
          {
            value: 0,
            label: 'AMP',
          },
        ],
      },
    },
    evoucher: {
      activationStatus: [
        {
          value: 1,
          label: 'Active',
        },
        {
          value: 0,
          label: 'Inactive',
        },
      ],
      redemptionStatus: [
        {
          value: 1,
          label: 'Redeemed',
        },
        {
          value: 0,
          label: 'Unredeemed',
        },
      ],
    },
    products: {
      consignmentOrderProductsOptions: [
        {
          value: 1,
          label: 'Stockist Consignment Order Product',
        },
        {
          value: 0,
          label: 'All Products',
        },
      ],
    },
    ewallet: {
      giroApprovalStatusOptions: [
        {
          value: null,
          label: 'All',
        },
        {
          value: -1,
          label: 'Pending',
        },
        {
          value: 0,
          label: 'Rejected',
        },
        {
          value: 1,
          label: 'Approved',
        },
      ],
    },
    filters: {
      sales: {
        includes: [],
        excludes: [CONST.masterData.EXCLUDE_FROM_SALES_FILTER],
      },
      enrolment: {
        includes: [],
        excludes: [CONST.masterData.EXCLUDE_FROM_SALES_FILTER],
      },
      rentalEnrolment: {
        includes: [],
        excludes: [CONST.masterData.EXCLUDE_FROM_SALES_FILTER],
      },
      rentalSales: {
        includes: [],
        excludes: [CONST.masterData.EXCLUDE_FROM_SALES_FILTER],
      },
      stockistConsignmentSales: {
        includes: [CONST.masterData.STOCKIST_CONSIGNMENT_ORDER_FILTER],
        excludes: [],
      },
      esacSales: {
        includes: [],
        excludes: [],
      },
      legacySalesExchangeSales: {
        includes: [],
        excludes: [CONST.masterData.EXCLUDE_FROM_SALES_FILTER],
      },
      salesExchangeSales: {
        includes: [],
        excludes: [CONST.masterData.EXCLUDE_FROM_SALES_FILTER],
      },
      autoshipSales: {
        includes: [CONST.masterData.AUTOSHIP],
        excludes: [],
      },
    },
    settings: {},
    members: {
      expiry_date_format: 'DD-MMM-YYYY',
    },
    redirect: {
      delay: 3000,
    },
    modules: {
      sales: {
        type: {
          normal: {
            payments: {
              exclude_payment_mode: ['Mega'],
              exclude_payment_mode_provider: [],
              exclude_payment_mode_is_skip_downline: [
                'AEON',
                'EPP (Moto)',
                'EPP (Online)',
                'EPP (Terminal)',
                'MPOS',
                'NETS',
              ],
            },
          },
          exchange: {
            payments: {
              exclude_payment_mode: ['Mega', 'SPS'],
              exclude_payment_mode_provider: [],
            },
          },
          legacy_exchange: {
            payments: {
              exclude_payment_mode: ['Mega'],
              exclude_payment_mode_provider: [],
            },
          },
          rental: {
            payments: {
              skip_process_form_validation: true,
              exclude_payment_mode: ['AEON', 'E-Wallet', 'Discount Voucher', 'SPS'],
              exclude_payment_mode_provider: [],
            },
          },
          rental_enrolment: {
            payments: {
              skip_process_form_validation: true,
              exclude_payment_mode: ['AEON', 'E-Wallet', 'Discount Voucher', 'SPS'],
              exclude_payment_mode_provider: [],
            },
          },
          enrolment: {
            payments: {
              exclude_payment_mode: ['Mega'],
              exclude_payment_mode_provider: [],
            },
          },
        },
      },
      stockist: {
        type: {
          consignment_deposit: {
            payments: {
              exclude_payment_mode: [
                'Mega',
                'AEON',
                'E-Wallet',
                'Discount Voucher',
                'EPP (Moto)',
                'Credit Card',
                'EPP (Terminal)',
                'Stockist Card (Cash)',
                'EPP (Online)',
                'epp_online_ipay88',
                'SPS',
              ],
              exclude_payment_mode_provider: [],
            },
          },
        },
      },
      esac: {
        type: {
          esac_redemption: {
            payments: {
              exclude_payment_mode: ['Mega', 'AEON', 'Discount Voucher', 'SPS'],
              exclude_payment_mode_provider: [],
            },
          },
        },
      },
    },
    smartLibrary: {
      eForm: {
        statusOptions: [
          {
            label: 'All',
            value: 2,
          },
          {
            label: 'Active',
            value: 1,
          },
          {
            label: 'Inactive',
            value: 0,
          },
        ],
      },
    },
  },
  dynamicContentData: {
    data: [],
  },
  statesOptions: {
    data: {
      options: [],
    },
  },
  citiesOptions: {
    data: {
      options: [],
    },
  },
  trashData: {
    data: [],
  },
  userInfo: {
    data: {},
  },
  banksOptions: {
    data: {
      options: [],
    },
  },
  done: false,
  memberSearchDataGlobal: {
    list: [],
  },
  countryRelation: {
    data: {},
  },
  headerSearchBarField: '',
  commissionWeeks: {
    list: [],
  },
  websocket: {
    connected: false,
    channels: [],
  },
  uploaderFileUploadSetting: {
    data: [],
  },
  isProcessingRefreshToken: false,
  /**
   *  R&P Schema for Elements
   *  e.g buttons,inputs and etc..
   *
   *  schema = [{
        path: 'sales.management.new', // Refers which route path element based permission are effected
        items: [ // Array of actions and it can be multiple e.g. create,update,delete,download or can be custom name
          {
            action: 'create', // Name of the action e.g. create,update,delete,download or can be custom name
            allowed: [ // Add all allowed User permissions
              'stockist.consignment.orders.return.detail.1.backoffice.view',  // check below for string explanation breakdown
              // [[stockist.consignment.orders.return.detail]] module name alias .[[1]] country id . [[backoffice]] user type .[[view]] backend permission
              // Follow exactly same string return by api-> user->permission array
            ],
          },
        ],
      }]
   */
  acl: {
    schema: [
      {
        path: 'sales.management.list',
        items: [
          {
            action: 'order',
            allowed: [
              'sales.management.new.1.backoffice.create',
              'sales.management.new.2.backoffice.create',
              'sales.management.new.3.backoffice.create',
              'sales.management.new.4.backoffice.create',
              'sales.management.new.5.backoffice.create',
              'sales.management.new.6.backoffice.create',
              'sales.management.new.7.backoffice.create',
              'sales.management.new.8.backoffice.create',
              'sales.management.new.9.backoffice.create',
              'sales.management.new.10.backoffice.create',
              'sales.management.new.233.backoffice.create',
              'sales.management.new.1.stockist.create',
              'sales.management.new.2.stockist.create',
              'sales.management.new.3.stockist.create',
              'sales.management.new.4.stockist.create',
              'sales.management.new.5.stockist.create',
              'sales.management.new.6.stockist.create',
              'sales.management.new.7.stockist.create',
              'sales.management.new.8.stockist.create',
              'sales.management.new.9.stockist.create',
              'sales.management.new.10.stockist.create',
              'sales.management.new.233.stockist.create',
              'sales.management.new.1.stockist_staff.create',
              'sales.management.new.2.stockist_staff.create',
              'sales.management.new.3.stockist_staff.create',
              'sales.management.new.4.stockist_staff.create',
              'sales.management.new.5.stockist_staff.create',
              'sales.management.new.6.stockist_staff.create',
              'sales.management.new.7.stockist_staff.create',
              'sales.management.new.8.stockist_staff.create',
              'sales.management.new.9.stockist_staff.create',
              'sales.management.new.10.stockist_staff.create',
              'sales.management.new.233.stockist_staff.create',
            ],
          },
        ],
      },
      {
        path: 'sales.management.new',
        items: [
          {
            action: 'create',
            allowed: [
              'sales.management.new.1.backoffice.create',
              'sales.management.new.2.backoffice.create',
              'sales.management.new.3.backoffice.create',
              'sales.management.new.4.backoffice.create',
              'sales.management.new.5.backoffice.create',
              'sales.management.new.6.backoffice.create',
              'sales.management.new.7.backoffice.create',
              'sales.management.new.8.backoffice.create',
              'sales.management.new.9.backoffice.create',
              'sales.management.new.10.backoffice.create',
              'sales.management.new.233.backoffice.create',
              'sales.management.new.1.stockist.create',
              'sales.management.new.2.stockist.create',
              'sales.management.new.3.stockist.create',
              'sales.management.new.4.stockist.create',
              'sales.management.new.5.stockist.create',
              'sales.management.new.6.stockist.create',
              'sales.management.new.7.stockist.create',
              'sales.management.new.8.stockist.create',
              'sales.management.new.9.stockist.create',
              'sales.management.new.10.stockist.create',
              'sales.management.new.233.stockist.create',
              'sales.management.new.1.stockist_staff.create',
              'sales.management.new.2.stockist_staff.create',
              'sales.management.new.3.stockist_staff.create',
              'sales.management.new.4.stockist_staff.create',
              'sales.management.new.5.stockist_staff.create',
              'sales.management.new.6.stockist_staff.create',
              'sales.management.new.7.stockist_staff.create',
              'sales.management.new.8.stockist_staff.create',
              'sales.management.new.9.stockist_staff.create',
              'sales.management.new.10.stockist_staff.create',
              'sales.management.new.233.stockist_staff.create',
            ],
          },
        ],
      },
      {
        path: 'sales.management.view',
        items: [
          {
            action: 'update',
            allowed: [
              'sales.management.view.1.backoffice.update',
              'sales.management.view.2.backoffice.update',
              'sales.management.view.3.backoffice.update',
              'sales.management.view.4.backoffice.update',
              'sales.management.view.5.backoffice.update',
              'sales.management.view.6.backoffice.update',
              'sales.management.view.7.backoffice.update',
              'sales.management.view.8.backoffice.update',
              'sales.management.view.9.backoffice.update',
              'sales.management.view.10.backoffice.update',
              'sales.management.view.233.backoffice.update',
              'sales.management.view.1.stockist.update',
              'sales.management.view.2.stockist.update',
              'sales.management.view.3.stockist.update',
              'sales.management.view.4.stockist.update',
              'sales.management.view.5.stockist.update',
              'sales.management.view.6.stockist.update',
              'sales.management.view.7.stockist.update',
              'sales.management.view.8.stockist.update',
              'sales.management.view.9.stockist.update',
              'sales.management.view.10.stockist.update',
              'sales.management.view.233.stockist.update',
              'sales.management.view.1.stockist_staff.update',
              'sales.management.view.2.stockist_staff.update',
              'sales.management.view.3.stockist_staff.update',
              'sales.management.view.4.stockist_staff.update',
              'sales.management.view.5.stockist_staff.update',
              'sales.management.view.6.stockist_staff.update',
              'sales.management.view.7.stockist_staff.update',
              'sales.management.view.8.stockist_staff.update',
              'sales.management.view.9.stockist_staff.update',
              'sales.management.view.10.stockist_staff.update',
              'sales.management.view.233.stockist_staff.update',
            ],
          },
        ],
      },
      {
        path: 'sales.management.rental.new',
        items: [
          {
            action: 'create',
            allowed: [
              'sales.management.rental.new.1.backoffice.create',
              'sales.management.rental.new.2.backoffice.create',
              'sales.management.rental.new.3.backoffice.create',
              'sales.management.rental.new.4.backoffice.create',
              'sales.management.rental.new.5.backoffice.create',
              'sales.management.rental.new.6.backoffice.create',
              'sales.management.rental.new.7.backoffice.create',
              'sales.management.rental.new.8.backoffice.create',
              'sales.management.rental.new.9.backoffice.create',
              'sales.management.rental.new.10.backoffice.create',
              'sales.management.rental.new.233.backoffice.create',
              'sales.management.rental.new.1.stockist.create',
              'sales.management.rental.new.2.stockist.create',
              'sales.management.rental.new.3.stockist.create',
              'sales.management.rental.new.4.stockist.create',
              'sales.management.rental.new.5.stockist.create',
              'sales.management.rental.new.6.stockist.create',
              'sales.management.rental.new.7.stockist.create',
              'sales.management.rental.new.8.stockist.create',
              'sales.management.rental.new.9.stockist.create',
              'sales.management.rental.new.10.stockist.create',
              'sales.management.rental.new.233.stockist.create',
              'sales.management.rental.new.1.stockist_staff.create',
              'sales.management.rental.new.2.stockist_staff.create',
              'sales.management.rental.new.3.stockist_staff.create',
              'sales.management.rental.new.4.stockist_staff.create',
              'sales.management.rental.new.5.stockist_staff.create',
              'sales.management.rental.new.6.stockist_staff.create',
              'sales.management.rental.new.7.stockist_staff.create',
              'sales.management.rental.new.8.stockist_staff.create',
              'sales.management.rental.new.9.stockist_staff.create',
              'sales.management.rental.new.10.stockist_staff.create',
              'sales.management.rental.new.233.stockist_staff.create',
            ],
          },
        ],
      },
      {
        path: 'sales.management.rental.view',
        items: [
          {
            action: 'update',
            allowed: [
              'sales.management.rental.view.1.backoffice.update',
              'sales.management.rental.view.2.backoffice.update',
              'sales.management.rental.view.3.backoffice.update',
              'sales.management.rental.view.4.backoffice.update',
              'sales.management.rental.view.5.backoffice.update',
              'sales.management.rental.view.6.backoffice.update',
              'sales.management.rental.view.7.backoffice.update',
              'sales.management.rental.view.8.backoffice.update',
              'sales.management.rental.view.9.backoffice.update',
              'sales.management.rental.view.10.backoffice.update',
              'sales.management.rental.view.233.backoffice.update',
              'sales.management.rental.view.1.stockist.update',
              'sales.management.rental.view.2.stockist.update',
              'sales.management.rental.view.3.stockist.update',
              'sales.management.rental.view.4.stockist.update',
              'sales.management.rental.view.5.stockist.update',
              'sales.management.rental.view.6.stockist.update',
              'sales.management.rental.view.7.stockist.update',
              'sales.management.rental.view.8.stockist.update',
              'sales.management.rental.view.9.stockist.update',
              'sales.management.rental.view.10.stockist.update',
              'sales.management.rental.view.233.stockist.update',
              'sales.management.rental.view.1.stockist_staff.update',
              'sales.management.rental.view.2.stockist_staff.update',
              'sales.management.rental.view.3.stockist_staff.update',
              'sales.management.rental.view.4.stockist_staff.update',
              'sales.management.rental.view.5.stockist_staff.update',
              'sales.management.rental.view.6.stockist_staff.update',
              'sales.management.rental.view.7.stockist_staff.update',
              'sales.management.rental.view.8.stockist_staff.update',
              'sales.management.rental.view.9.stockist_staff.update',
              'sales.management.rental.view.10.stockist_staff.update',
              'sales.management.rental.view.233.stockist_staff.update',
            ],
          },
        ],
      },
      {
        path: 'sales.management.enrolment.rental',
        items: [
          {
            action: 'create',
            allowed: [
              'sales.management.enrolment.rental.1.backoffice.create',
              'sales.management.enrolment.rental.2.backoffice.create',
              'sales.management.enrolment.rental.3.backoffice.create',
              'sales.management.enrolment.rental.4.backoffice.create',
              'sales.management.enrolment.rental.5.backoffice.create',
              'sales.management.enrolment.rental.6.backoffice.create',
              'sales.management.enrolment.rental.7.backoffice.create',
              'sales.management.enrolment.rental.8.backoffice.create',
              'sales.management.enrolment.rental.9.backoffice.create',
              'sales.management.enrolment.rental.10.backoffice.create',
              'sales.management.enrolment.rental.233.backoffice.create',
              'sales.management.enrolment.rental.1.stockist.create',
              'sales.management.enrolment.rental.2.stockist.create',
              'sales.management.enrolment.rental.3.stockist.create',
              'sales.management.enrolment.rental.4.stockist.create',
              'sales.management.enrolment.rental.5.stockist.create',
              'sales.management.enrolment.rental.6.stockist.create',
              'sales.management.enrolment.rental.7.stockist.create',
              'sales.management.enrolment.rental.8.stockist.create',
              'sales.management.enrolment.rental.9.stockist.create',
              'sales.management.enrolment.rental.10.stockist.create',
              'sales.management.enrolment.rental.233.stockist.create',
              'sales.management.enrolment.rental.1.stockist_staff.create',
              'sales.management.enrolment.rental.2.stockist_staff.create',
              'sales.management.enrolment.rental.3.stockist_staff.create',
              'sales.management.enrolment.rental.4.stockist_staff.create',
              'sales.management.enrolment.rental.5.stockist_staff.create',
              'sales.management.enrolment.rental.6.stockist_staff.create',
              'sales.management.enrolment.rental.7.stockist_staff.create',
              'sales.management.enrolment.rental.8.stockist_staff.create',
              'sales.management.enrolment.rental.9.stockist_staff.create',
              'sales.management.enrolment.rental.10.stockist_staff.create',
              'sales.management.enrolment.rental.233.stockist_staff.create',
            ],
          },
        ],
      },
      {
        path: 'sales.management.enrolment.rental.view',
        items: [
          {
            action: 'update',
            allowed: [
              'sales.management.enrolment.rental.view.1.backoffice.update',
              'sales.management.enrolment.rental.view.2.backoffice.update',
              'sales.management.enrolment.rental.view.3.backoffice.update',
              'sales.management.enrolment.rental.view.4.backoffice.update',
              'sales.management.enrolment.rental.view.5.backoffice.update',
              'sales.management.enrolment.rental.view.6.backoffice.update',
              'sales.management.enrolment.rental.view.7.backoffice.update',
              'sales.management.enrolment.rental.view.8.backoffice.update',
              'sales.management.enrolment.rental.view.9.backoffice.update',
              'sales.management.enrolment.rental.view.10.backoffice.update',
              'sales.management.enrolment.rental.view.233.backoffice.update',
              'sales.management.enrolment.rental.view.1.stockist.update',
              'sales.management.enrolment.rental.view.2.stockist.update',
              'sales.management.enrolment.rental.view.3.stockist.update',
              'sales.management.enrolment.rental.view.4.stockist.update',
              'sales.management.enrolment.rental.view.5.stockist.update',
              'sales.management.enrolment.rental.view.6.stockist.update',
              'sales.management.enrolment.rental.view.7.stockist.update',
              'sales.management.enrolment.rental.view.8.stockist.update',
              'sales.management.enrolment.rental.view.9.stockist.update',
              'sales.management.enrolment.rental.view.10.stockist.update',
              'sales.management.enrolment.rental.view.233.stockist.update',
              'sales.management.enrolment.rental.view.1.stockist_staff.update',
              'sales.management.enrolment.rental.view.2.stockist_staff.update',
              'sales.management.enrolment.rental.view.3.stockist_staff.update',
              'sales.management.enrolment.rental.view.4.stockist_staff.update',
              'sales.management.enrolment.rental.view.5.stockist_staff.update',
              'sales.management.enrolment.rental.view.6.stockist_staff.update',
              'sales.management.enrolment.rental.view.7.stockist_staff.update',
              'sales.management.enrolment.rental.view.8.stockist_staff.update',
              'sales.management.enrolment.rental.view.9.stockist_staff.update',
              'sales.management.enrolment.rental.view.10.stockist_staff.update',
              'sales.management.enrolment.rental.view.233.stockist_staff.update',
            ],
          },
        ],
      },
      {
        path: 'sales.management.enrolment',
        items: [
          {
            action: 'create',
            allowed: [
              'sales.management.enrolment.1.backoffice.create',
              'sales.management.enrolment.2.backoffice.create',
              'sales.management.enrolment.3.backoffice.create',
              'sales.management.enrolment.4.backoffice.create',
              'sales.management.enrolment.5.backoffice.create',
              'sales.management.enrolment.6.backoffice.create',
              'sales.management.enrolment.7.backoffice.create',
              'sales.management.enrolment.8.backoffice.create',
              'sales.management.enrolment.9.backoffice.create',
              'sales.management.enrolment.10.backoffice.create',
              'sales.management.enrolment.233.backoffice.create',
              'sales.management.enrolment.1.stockist.create',
              'sales.management.enrolment.2.stockist.create',
              'sales.management.enrolment.3.stockist.create',
              'sales.management.enrolment.4.stockist.create',
              'sales.management.enrolment.5.stockist.create',
              'sales.management.enrolment.6.stockist.create',
              'sales.management.enrolment.7.stockist.create',
              'sales.management.enrolment.8.stockist.create',
              'sales.management.enrolment.9.stockist.create',
              'sales.management.enrolment.10.stockist.create',
              'sales.management.enrolment.233.stockist.create',
              'sales.management.enrolment.1.stockist_staff.create',
              'sales.management.enrolment.2.stockist_staff.create',
              'sales.management.enrolment.3.stockist_staff.create',
              'sales.management.enrolment.4.stockist_staff.create',
              'sales.management.enrolment.5.stockist_staff.create',
              'sales.management.enrolment.6.stockist_staff.create',
              'sales.management.enrolment.7.stockist_staff.create',
              'sales.management.enrolment.8.stockist_staff.create',
              'sales.management.enrolment.9.stockist_staff.create',
              'sales.management.enrolment.10.stockist_staff.create',
              'sales.management.enrolment.233.stockist_staff.create',
            ],
          },
        ],
      },
      {
        path: 'sales.management.enrolment.view',
        items: [
          {
            action: 'update',
            allowed: [
              'sales.management.view.1.backoffice.update',
              'sales.management.view.2.backoffice.update',
              'sales.management.view.3.backoffice.update',
              'sales.management.view.4.backoffice.update',
              'sales.management.view.5.backoffice.update',
              'sales.management.view.6.backoffice.update',
              'sales.management.view.7.backoffice.update',
              'sales.management.view.8.backoffice.update',
              'sales.management.view.9.backoffice.update',
              'sales.management.view.10.backoffice.update',
              'sales.management.view.233.backoffice.update',
              'sales.management.view.1.stockist.update',
              'sales.management.view.2.stockist.update',
              'sales.management.view.3.stockist.update',
              'sales.management.view.4.stockist.update',
              'sales.management.view.5.stockist.update',
              'sales.management.view.6.stockist.update',
              'sales.management.view.7.stockist.update',
              'sales.management.view.8.stockist.update',
              'sales.management.view.9.stockist.update',
              'sales.management.view.10.stockist.update',
              'sales.management.view.233.stockist.update',
              'sales.management.view.1.stockist_staff.update',
              'sales.management.view.2.stockist_staff.update',
              'sales.management.view.3.stockist_staff.update',
              'sales.management.view.4.stockist_staff.update',
              'sales.management.view.5.stockist_staff.update',
              'sales.management.view.6.stockist_staff.update',
              'sales.management.view.7.stockist_staff.update',
              'sales.management.view.8.stockist_staff.update',
              'sales.management.view.9.stockist_staff.update',
              'sales.management.view.10.stockist_staff.update',
              'sales.management.view.233.stockist_staff.update',
            ],
          },
        ],
      },
      {
        path: 'sales.management.cancellation',
        items: [
          {
            action: 'new',
            allowed: [
              'sales.cancellation.new.1.backoffice.new',
              'sales.cancellation.new.2.backoffice.new',
              'sales.cancellation.new.3.backoffice.new',
              'sales.cancellation.new.4.backoffice.new',
              'sales.cancellation.new.5.backoffice.new',
              'sales.cancellation.new.6.backoffice.new',
              'sales.cancellation.new.7.backoffice.new',
              'sales.cancellation.new.8.backoffice.new',
              'sales.cancellation.new.9.backoffice.new',
              'sales.cancellation.new.10.backoffice.new',
              'sales.cancellation.new.233.backoffice.new',
              'sales.cancellation.new.1.stockist.new',
              'sales.cancellation.new.2.stockist.new',
              'sales.cancellation.new.3.stockist.new',
              'sales.cancellation.new.4.stockist.new',
              'sales.cancellation.new.5.stockist.new',
              'sales.cancellation.new.6.stockist.new',
              'sales.cancellation.new.7.stockist.new',
              'sales.cancellation.new.8.stockist.new',
              'sales.cancellation.new.9.stockist.new',
              'sales.cancellation.new.10.stockist.new',
              'sales.cancellation.new.233.stockist.new',
              'sales.cancellation.new.1.stockist_staff.new',
              'sales.cancellation.new.2.stockist_staff.new',
              'sales.cancellation.new.3.stockist_staff.new',
              'sales.cancellation.new.4.stockist_staff.new',
              'sales.cancellation.new.5.stockist_staff.new',
              'sales.cancellation.new.6.stockist_staff.new',
              'sales.cancellation.new.7.stockist_staff.new',
              'sales.cancellation.new.8.stockist_staff.new',
              'sales.cancellation.new.9.stockist_staff.new',
              'sales.cancellation.new.10.stockist_staff.new',
              'sales.cancellation.new.233.stockist_staff.new',
            ],
          },
        ],
      },
      {
        path: 'sales.management.aeon.list',
        items: [
          {
            action: 'update',
            allowed: [
              'sales.management.aeon.list.1.backoffice.update',
              'sales.management.aeon.list.2.backoffice.update',
              'sales.management.aeon.list.3.backoffice.update',
              'sales.management.aeon.list.4.backoffice.update',
              'sales.management.aeon.list.5.backoffice.update',
              'sales.management.aeon.list.6.backoffice.update',
              'sales.management.aeon.list.7.backoffice.update',
              'sales.management.aeon.list.8.backoffice.update',
              'sales.management.aeon.list.9.backoffice.update',
              'sales.management.aeon.list.10.backoffice.update',
              'sales.management.aeon.list.233.backoffice.update',
            ],
          },
        ],
      },
      {
        path: 'sales.management.epp.list',
        items: [
          {
            action: 'update',
            allowed: [
              'sales.management.epp.list.1.backoffice.update',
              'sales.management.epp.list.2.backoffice.update',
              'sales.management.epp.list.3.backoffice.update',
              'sales.management.epp.list.4.backoffice.update',
              'sales.management.epp.list.5.backoffice.update',
              'sales.management.epp.list.6.backoffice.update',
              'sales.management.epp.list.7.backoffice.update',
              'sales.management.epp.list.8.backoffice.update',
              'sales.management.epp.list.9.backoffice.update',
              'sales.management.epp.list.10.backoffice.update',
              'sales.management.epp.list.233.backoffice.update',
              'sales.management.epp.list.1.stockist.update',
              'sales.management.epp.list.2.stockist.update',
              'sales.management.epp.list.3.stockist.update',
              'sales.management.epp.list.4.stockist.update',
              'sales.management.epp.list.5.stockist.update',
              'sales.management.epp.list.6.stockist.update',
              'sales.management.epp.list.7.stockist.update',
              'sales.management.epp.list.8.stockist.update',
              'sales.management.epp.list.9.stockist.update',
              'sales.management.epp.list.10.stockist.update',
              'sales.management.epp.list.233.stockist.update',
              'sales.management.epp.list.1.stockist_staff.update',
              'sales.management.epp.list.2.stockist_staff.update',
              'sales.management.epp.list.3.stockist_staff.update',
              'sales.management.epp.list.4.stockist_staff.update',
              'sales.management.epp.list.5.stockist_staff.update',
              'sales.management.epp.list.6.stockist_staff.update',
              'sales.management.epp.list.7.stockist_staff.update',
              'sales.management.epp.list.8.stockist_staff.update',
              'sales.management.epp.list.9.stockist_staff.update',
              'sales.management.epp.list.10.stockist_staff.update',
              'sales.management.epp.list.233.stockist_staff.update',
            ],
          },
        ],
      },
      {
        path: 'stockist.funds.list',
        items: [
          {
            action: 'deposit',
            allowed: [
              'stockist.funds.new.1.stockist.create',
              'stockist.funds.new.2.stockist.create',
              'stockist.funds.new.3.stockist.create',
              'stockist.funds.new.4.stockist.create',
              'stockist.funds.new.5.stockist.create',
              'stockist.funds.new.6.stockist.create',
              'stockist.funds.new.7.stockist.create',
              'stockist.funds.new.8.stockist.create',
              'stockist.funds.new.9.stockist.create',
              'stockist.funds.new.10.stockist.create',
              'stockist.funds.new.233.stockist.create',
              'stockist.funds.new.1.backoffice.create',
              'stockist.funds.new.2.backoffice.create',
              'stockist.funds.new.3.backoffice.create',
              'stockist.funds.new.4.backoffice.create',
              'stockist.funds.new.5.backoffice.create',
              'stockist.funds.new.6.backoffice.create',
              'stockist.funds.new.7.backoffice.create',
              'stockist.funds.new.8.backoffice.create',
              'stockist.funds.new.9.backoffice.create',
              'stockist.funds.new.10.backoffice.create',
              'stockist.funds.new.233.backoffice.create',
              'stockist.funds.new.1.stockist_staff.create',
              'stockist.funds.new.2.stockist_staff.create',
              'stockist.funds.new.3.stockist_staff.create',
              'stockist.funds.new.4.stockist_staff.create',
              'stockist.funds.new.5.stockist_staff.create',
              'stockist.funds.new.6.stockist_staff.create',
              'stockist.funds.new.7.stockist_staff.create',
              'stockist.funds.new.8.stockist_staff.create',
              'stockist.funds.new.9.stockist_staff.create',
              'stockist.funds.new.10.stockist_staff.create',
              'stockist.funds.new.233.stockist_staff.create',
            ],
          },
          {
            action: 'refund',
            allowed: [
              'stockist.funds.new.1.stockist.create',
              'stockist.funds.new.2.stockist.create',
              'stockist.funds.new.3.stockist.create',
              'stockist.funds.new.4.stockist.create',
              'stockist.funds.new.5.stockist.create',
              'stockist.funds.new.6.stockist.create',
              'stockist.funds.new.7.stockist.create',
              'stockist.funds.new.8.stockist.create',
              'stockist.funds.new.9.stockist.create',
              'stockist.funds.new.10.stockist.create',
              'stockist.funds.new.233.stockist.create',
              'stockist.funds.new.1.backoffice.create',
              'stockist.funds.new.2.backoffice.create',
              'stockist.funds.new.3.backoffice.create',
              'stockist.funds.new.4.backoffice.create',
              'stockist.funds.new.5.backoffice.create',
              'stockist.funds.new.6.backoffice.create',
              'stockist.funds.new.7.backoffice.create',
              'stockist.funds.new.8.backoffice.create',
              'stockist.funds.new.9.backoffice.create',
              'stockist.funds.new.10.backoffice.create',
              'stockist.funds.new.233.backoffice.create',
              'stockist.funds.new.1.stockist_staff.create',
              'stockist.funds.new.2.stockist_staff.create',
              'stockist.funds.new.3.stockist_staff.create',
              'stockist.funds.new.4.stockist_staff.create',
              'stockist.funds.new.5.stockist_staff.create',
              'stockist.funds.new.6.stockist_staff.create',
              'stockist.funds.new.7.stockist_staff.create',
              'stockist.funds.new.8.stockist_staff.create',
              'stockist.funds.new.9.stockist_staff.create',
              'stockist.funds.new.10.stockist_staff.create',
              'stockist.funds.new.233.stockist_staff.create',
            ],
          },
        ],
      },
      {
        path: 'stockist.transaction.list',
        items: [
          {
            action: 'release',
            allowed: [
              'stockist.transactions.release.update.1.stockist.update',
              'stockist.transactions.release.update.2.stockist.update',
              'stockist.transactions.release.update.3.stockist.update',
              'stockist.transactions.release.update.4.stockist.update',
              'stockist.transactions.release.update.5.stockist.update',
              'stockist.transactions.release.update.6.stockist.update',
              'stockist.transactions.release.update.7.stockist.update',
              'stockist.transactions.release.update.8.stockist.update',
              'stockist.transactions.release.update.9.stockist.update',
              'stockist.transactions.release.update.10.stockist.update',
              'stockist.transactions.release.update.233.stockist.update',
              'stockist.transactions.release.update.1.backoffice.update',
              'stockist.transactions.release.update.2.backoffice.update',
              'stockist.transactions.release.update.3.backoffice.update',
              'stockist.transactions.release.update.4.backoffice.update',
              'stockist.transactions.release.update.5.backoffice.update',
              'stockist.transactions.release.update.6.backoffice.update',
              'stockist.transactions.release.update.7.backoffice.update',
              'stockist.transactions.release.update.8.backoffice.update',
              'stockist.transactions.release.update.9.backoffice.update',
              'stockist.transactions.release.update.10.backoffice.update',
              'stockist.transactions.release.update.233.backoffice.update',
              'stockist.transactions.release.update.1.stockist_staff.update',
              'stockist.transactions.release.update.2.stockist_staff.update',
              'stockist.transactions.release.update.3.stockist_staff.update',
              'stockist.transactions.release.update.4.stockist_staff.update',
              'stockist.transactions.release.update.5.stockist_staff.update',
              'stockist.transactions.release.update.6.stockist_staff.update',
              'stockist.transactions.release.update.7.stockist_staff.update',
              'stockist.transactions.release.update.8.stockist_staff.update',
              'stockist.transactions.release.update.9.stockist_staff.update',
              'stockist.transactions.release.update.10.stockist_staff.update',
              'stockist.transactions.release.update.233.stockist_staff.update',
            ],
          },
        ],
      },
      {
        path: 'stockist.funds.detail',
        items: [
          {
            action: 'files',
            allowed: [
              'stockist.funds.files.note.download.1.stockist.download',
              'stockist.funds.files.note.download.2.stockist.download',
              'stockist.funds.files.note.download.3.stockist.download',
              'stockist.funds.files.note.download.4.stockist.download',
              'stockist.funds.files.note.download.5.stockist.download',
              'stockist.funds.files.note.download.6.stockist.download',
              'stockist.funds.files.note.download.7.stockist.download',
              'stockist.funds.files.note.download.8.stockist.download',
              'stockist.funds.files.note.download.9.stockist.download',
              'stockist.funds.files.note.download.10.stockist.download',
              'stockist.funds.files.note.download.233.stockist.download',
              'stockist.funds.files.note.download.1.backoffice.download',
              'stockist.funds.files.note.download.2.backoffice.download',
              'stockist.funds.files.note.download.3.backoffice.download',
              'stockist.funds.files.note.download.4.backoffice.download',
              'stockist.funds.files.note.download.5.backoffice.download',
              'stockist.funds.files.note.download.6.backoffice.download',
              'stockist.funds.files.note.download.7.backoffice.download',
              'stockist.funds.files.note.download.8.backoffice.download',
              'stockist.funds.files.note.download.9.backoffice.download',
              'stockist.funds.files.note.download.10.backoffice.download',
              'stockist.funds.files.note.download.233.backoffice.download',
              'stockist.funds.files.note.download.1.stockist_staff.download',
              'stockist.funds.files.note.download.2.stockist_staff.download',
              'stockist.funds.files.note.download.3.stockist_staff.download',
              'stockist.funds.files.note.download.4.stockist_staff.download',
              'stockist.funds.files.note.download.5.stockist_staff.download',
              'stockist.funds.files.note.download.6.stockist_staff.download',
              'stockist.funds.files.note.download.7.stockist_staff.download',
              'stockist.funds.files.note.download.8.stockist_staff.download',
              'stockist.funds.files.note.download.9.stockist_staff.download',
              'stockist.funds.files.note.download.10.stockist_staff.download',
              'stockist.funds.files.note.download.233.stockist_staff.download',
            ],
          },
          {
            action: 'workflow-approval',
            allowed: [
              'stockist.funds.detail.1.backoffice.update',
              'stockist.funds.detail.2.backoffice.update',
              'stockist.funds.detail.3.backoffice.update',
              'stockist.funds.detail.4.backoffice.update',
              'stockist.funds.detail.5.backoffice.update',
              'stockist.funds.detail.6.backoffice.update',
              'stockist.funds.detail.7.backoffice.update',
              'stockist.funds.detail.8.backoffice.update',
              'stockist.funds.detail.9.backoffice.update',
              'stockist.funds.detail.10.backoffice.update',
              'stockist.funds.detail.233.backoffice.update',
            ],
          },
        ],
      },
      {
        path: 'stockist.consignment.orders.sales.detail.sales',
        items: [
          {
            action: 'workflow-approval',
            allowed: [
              'stockist.consignment.orders.sales.detail.1.backoffice.view',
              'stockist.consignment.orders.sales.detail.2.backoffice.view',
              'stockist.consignment.orders.sales.detail.3.backoffice.view',
              'stockist.consignment.orders.sales.detail.4.backoffice.view',
              'stockist.consignment.orders.sales.detail.5.backoffice.view',
              'stockist.consignment.orders.sales.detail.6.backoffice.view',
              'stockist.consignment.orders.sales.detail.7.backoffice.view',
              'stockist.consignment.orders.sales.detail.8.backoffice.view',
              'stockist.consignment.orders.sales.detail.9.backoffice.view',
              'stockist.consignment.orders.sales.detail.10.backoffice.view',
              'stockist.consignment.orders.sales.detail.233.backoffice.view',
            ],
          },
        ],
      },
      {
        path: 'stockist.consignment.orders.sales.detail.return',
        items: [
          {
            action: 'workflow-approval',
            allowed: [
              'stockist.consignment.orders.return.detail.1.backoffice.view',
              'stockist.consignment.orders.return.detail.2.backoffice.view',
              'stockist.consignment.orders.return.detail.3.backoffice.view',
              'stockist.consignment.orders.return.detail.4.backoffice.view',
              'stockist.consignment.orders.return.detail.5.backoffice.view',
              'stockist.consignment.orders.return.detail.6.backoffice.view',
              'stockist.consignment.orders.return.detail.7.backoffice.view',
              'stockist.consignment.orders.return.detail.8.backoffice.view',
              'stockist.consignment.orders.return.detail.9.backoffice.view',
              'stockist.consignment.orders.return.detail.10.backoffice.view',
              'stockist.consignment.orders.return.detail.233.backoffice.view',
            ],
          },
        ],
      },
      {
        path: 'invoice',
        items: [
          {
            action: 'download',
            allowed: [
              'invoices.download.1.backoffice.download',
              'invoices.download.2.backoffice.download',
              'invoices.download.3.backoffice.download',
              'invoices.download.4.backoffice.download',
              'invoices.download.5.backoffice.download',
              'invoices.download.6.backoffice.download',
              'invoices.download.7.backoffice.download',
              'invoices.download.8.backoffice.download',
              'invoices.download.9.backoffice.download',
              'invoices.download.10.backoffice.download',
              'invoices.download.233.backoffice.download',
              'invoices.download.1.stockist.download',
              'invoices.download.2.stockist.download',
              'invoices.download.3.stockist.download',
              'invoices.download.4.stockist.download',
              'invoices.download.5.stockist.download',
              'invoices.download.6.stockist.download',
              'invoices.download.7.stockist.download',
              'invoices.download.8.stockist.download',
              'invoices.download.9.stockist.download',
              'invoices.download.10.stockist.download',
              'invoices.download.233.stockist.download',
              'invoices.download.1.stockist_staff.download',
              'invoices.download.2.stockist_staff.download',
              'invoices.download.3.stockist_staff.download',
              'invoices.download.4.stockist_staff.download',
              'invoices.download.5.stockist_staff.download',
              'invoices.download.6.stockist_staff.download',
              'invoices.download.7.stockist_staff.download',
              'invoices.download.8.stockist_staff.download',
              'invoices.download.9.stockist_staff.download',
              'invoices.download.10.stockist_staff.download',
              'invoices.download.233.stockist_staff.download',
            ],
          },
        ],
      },
      {
        path: 'campaigns.management.campaign.create',
        items: [
          {
            action: 'create',
            allowed: [
              'campaigns.management.campaign.create.1.backoffice.create',
              'campaigns.management.campaign.create.2.backoffice.create',
              'campaigns.management.campaign.create.3.backoffice.create',
              'campaigns.management.campaign.create.4.backoffice.create',
              'campaigns.management.campaign.create.5.backoffice.create',
              'campaigns.management.campaign.create.6.backoffice.create',
              'campaigns.management.campaign.create.7.backoffice.create',
              'campaigns.management.campaign.create.8.backoffice.create',
              'campaigns.management.campaign.create.9.backoffice.create',
              'campaigns.management.campaign.create.10.backoffice.create',
              'campaigns.management.campaign.create.233.backoffice.create',
              'campaigns.management.campaign.create.1.stockist.create',
              'campaigns.management.campaign.create.2.stockist.create',
              'campaigns.management.campaign.create.3.stockist.create',
              'campaigns.management.campaign.create.4.stockist.create',
              'campaigns.management.campaign.create.5.stockist.create',
              'campaigns.management.campaign.create.6.stockist.create',
              'campaigns.management.campaign.create.7.stockist.create',
              'campaigns.management.campaign.create.8.stockist.create',
              'campaigns.management.campaign.create.9.stockist.create',
              'campaigns.management.campaign.create.10.stockist.create',
              'campaigns.management.campaign.create.233.stockist.create',
              'campaigns.management.campaign.create.1.stockist_staff.create',
              'campaigns.management.campaign.create.2.stockist_staff.create',
              'campaigns.management.campaign.create.3.stockist_staff.create',
              'campaigns.management.campaign.create.4.stockist_staff.create',
              'campaigns.management.campaign.create.5.stockist_staff.create',
              'campaigns.management.campaign.create.6.stockist_staff.create',
              'campaigns.management.campaign.create.7.stockist_staff.create',
              'campaigns.management.campaign.create.8.stockist_staff.create',
              'campaigns.management.campaign.create.9.stockist_staff.create',
              'campaigns.management.campaign.create.10.stockist_staff.create',
              'campaigns.management.campaign.create.233.stockist_staff.create',
            ],
          },
        ],
      },
      {
        path: 'campaigns.management.campaign.update',
        items: [
          {
            action: 'update',
            allowed: [
              'campaigns.management.campaign.update.1.backoffice.update',
              'campaigns.management.campaign.update.2.backoffice.update',
              'campaigns.management.campaign.update.3.backoffice.update',
              'campaigns.management.campaign.update.4.backoffice.update',
              'campaigns.management.campaign.update.5.backoffice.update',
              'campaigns.management.campaign.update.6.backoffice.update',
              'campaigns.management.campaign.update.7.backoffice.update',
              'campaigns.management.campaign.update.8.backoffice.update',
              'campaigns.management.campaign.update.9.backoffice.update',
              'campaigns.management.campaign.update.10.backoffice.update',
              'campaigns.management.campaign.update.233.backoffice.update',
              'campaigns.management.campaign.update.1.stockist.update',
              'campaigns.management.campaign.update.2.stockist.update',
              'campaigns.management.campaign.update.3.stockist.update',
              'campaigns.management.campaign.update.4.stockist.update',
              'campaigns.management.campaign.update.5.stockist.update',
              'campaigns.management.campaign.update.6.stockist.update',
              'campaigns.management.campaign.update.7.stockist.update',
              'campaigns.management.campaign.update.8.stockist.update',
              'campaigns.management.campaign.update.9.stockist.update',
              'campaigns.management.campaign.update.10.stockist.update',
              'campaigns.management.campaign.update.233.stockist.update',
              'campaigns.management.campaign.update.1.stockist_staff.update',
              'campaigns.management.campaign.update.2.stockist_staff.update',
              'campaigns.management.campaign.update.3.stockist_staff.update',
              'campaigns.management.campaign.update.4.stockist_staff.update',
              'campaigns.management.campaign.update.5.stockist_staff.update',
              'campaigns.management.campaign.update.6.stockist_staff.update',
              'campaigns.management.campaign.update.7.stockist_staff.update',
              'campaigns.management.campaign.update.8.stockist_staff.update',
              'campaigns.management.campaign.update.9.stockist_staff.update',
              'campaigns.management.campaign.update.10.stockist_staff.update',
              'campaigns.management.campaign.update.233.stockist_staff.update',
            ],
          },
        ],
      },
      {
        path: 'campaigns.management.esac.redemption.create',
        items: [
          {
            action: 'create',
            allowed: [
              'campaigns.management.esac.redemption.create.1.backoffice.create',
              'campaigns.management.esac.redemption.create.2.backoffice.create',
              'campaigns.management.esac.redemption.create.3.backoffice.create',
              'campaigns.management.esac.redemption.create.4.backoffice.create',
              'campaigns.management.esac.redemption.create.5.backoffice.create',
              'campaigns.management.esac.redemption.create.6.backoffice.create',
              'campaigns.management.esac.redemption.create.7.backoffice.create',
              'campaigns.management.esac.redemption.create.8.backoffice.create',
              'campaigns.management.esac.redemption.create.9.backoffice.create',
              'campaigns.management.esac.redemption.create.10.backoffice.create',
              'campaigns.management.esac.redemption.create.233.backoffice.create',
              'campaigns.management.esac.redemption.create.1.stockist.create',
              'campaigns.management.esac.redemption.create.2.stockist.create',
              'campaigns.management.esac.redemption.create.3.stockist.create',
              'campaigns.management.esac.redemption.create.4.stockist.create',
              'campaigns.management.esac.redemption.create.5.stockist.create',
              'campaigns.management.esac.redemption.create.6.stockist.create',
              'campaigns.management.esac.redemption.create.7.stockist.create',
              'campaigns.management.esac.redemption.create.8.stockist.create',
              'campaigns.management.esac.redemption.create.9.stockist.create',
              'campaigns.management.esac.redemption.create.10.stockist.create',
              'campaigns.management.esac.redemption.create.233.stockist.create',
              'campaigns.management.esac.redemption.create.1.stockist_staff.create',
              'campaigns.management.esac.redemption.create.2.stockist_staff.create',
              'campaigns.management.esac.redemption.create.3.stockist_staff.create',
              'campaigns.management.esac.redemption.create.4.stockist_staff.create',
              'campaigns.management.esac.redemption.create.5.stockist_staff.create',
              'campaigns.management.esac.redemption.create.6.stockist_staff.create',
              'campaigns.management.esac.redemption.create.7.stockist_staff.create',
              'campaigns.management.esac.redemption.create.8.stockist_staff.create',
              'campaigns.management.esac.redemption.create.9.stockist_staff.create',
              'campaigns.management.esac.redemption.create.10.stockist_staff.create',
              'campaigns.management.esac.redemption.create.233.stockist_staff.create',
            ],
          },
        ],
      },
      {
        path: 'campaigns.management.esac.redemption.update',
        items: [
          {
            action: 'update',
            allowed: [
              'campaigns.management.esac.redemption.update.1.backoffice.update',
              'campaigns.management.esac.redemption.update.2.backoffice.update',
              'campaigns.management.esac.redemption.update.3.backoffice.update',
              'campaigns.management.esac.redemption.update.4.backoffice.update',
              'campaigns.management.esac.redemption.update.5.backoffice.update',
              'campaigns.management.esac.redemption.update.6.backoffice.update',
              'campaigns.management.esac.redemption.update.7.backoffice.update',
              'campaigns.management.esac.redemption.update.8.backoffice.update',
              'campaigns.management.esac.redemption.update.9.backoffice.update',
              'campaigns.management.esac.redemption.update.10.backoffice.update',
              'campaigns.management.esac.redemption.update.233.backoffice.update',
              'campaigns.management.esac.redemption.update.1.stockist.update',
              'campaigns.management.esac.redemption.update.2.stockist.update',
              'campaigns.management.esac.redemption.update.3.stockist.update',
              'campaigns.management.esac.redemption.update.4.stockist.update',
              'campaigns.management.esac.redemption.update.5.stockist.update',
              'campaigns.management.esac.redemption.update.6.stockist.update',
              'campaigns.management.esac.redemption.update.7.stockist.update',
              'campaigns.management.esac.redemption.update.8.stockist.update',
              'campaigns.management.esac.redemption.update.9.stockist.update',
              'campaigns.management.esac.redemption.update.10.stockist.update',
              'campaigns.management.esac.redemption.update.233.stockist.update',
              'campaigns.management.esac.redemption.update.1.stockist_staff.update',
              'campaigns.management.esac.redemption.update.2.stockist_staff.update',
              'campaigns.management.esac.redemption.update.3.stockist_staff.update',
              'campaigns.management.esac.redemption.update.4.stockist_staff.update',
              'campaigns.management.esac.redemption.update.5.stockist_staff.update',
              'campaigns.management.esac.redemption.update.6.stockist_staff.update',
              'campaigns.management.esac.redemption.update.7.stockist_staff.update',
              'campaigns.management.esac.redemption.update.8.stockist_staff.update',
              'campaigns.management.esac.redemption.update.9.stockist_staff.update',
              'campaigns.management.esac.redemption.update.10.stockist_staff.update',
              'campaigns.management.esac.redemption.update.233.stockist_staff.update',
            ],
          },
        ],
      },
      {
        path: 'members',
        items: [
          {
            action: 'loginas',
            allowed: [
              'loginAs.setup.view.1.backoffice.view',
              'loginAs.setup.view.2.backoffice.view',
              'loginAs.setup.view.3.backoffice.view',
              'loginAs.setup.view.4.backoffice.view',
              'loginAs.setup.view.5.backoffice.view',
              'loginAs.setup.view.6.backoffice.view',
              'loginAs.setup.view.7.backoffice.view',
              'loginAs.setup.view.8.backoffice.view',
              'loginAs.setup.view.9.backoffice.view',
              'loginAs.setup.view.10.backoffice.view',
              'loginAs.setup.view.233.backoffice.view',
            ],
          },
        ],
      },
      {
        path: 'settings.department.setup',
        items: [
          {
            action: 'new',
            allowed: [
              'settings.department.create.1.backoffice.create',
              'settings.department.create.2.backoffice.create',
              'settings.department.create.3.backoffice.create',
              'settings.department.create.4.backoffice.create',
              'settings.department.create.5.backoffice.create',
              'settings.department.create.6.backoffice.create',
              'settings.department.create.7.backoffice.create',
              'settings.department.create.8.backoffice.create',
              'settings.department.create.9.backoffice.create',
              'settings.department.create.10.backoffice.create',
            ],
          },
        ],
      },
      {
        path: 'bonus.management.sv.manual.update.list',
        items: [
          {
            action: 'new',
            allowed: [
              'bonus.management.sv.manual.update.new.1.backoffice.create',
              'bonus.management.sv.manual.update.new.2.backoffice.create',
              'bonus.management.sv.manual.update.new.3.backoffice.create',
              'bonus.management.sv.manual.update.new.4.backoffice.create',
              'bonus.management.sv.manual.update.new.5.backoffice.create',
              'bonus.management.sv.manual.update.new.6.backoffice.create',
              'bonus.management.sv.manual.update.new.7.backoffice.create',
              'bonus.management.sv.manual.update.new.8.backoffice.create',
              'bonus.management.sv.manual.update.new.9.backoffice.create',
              'bonus.management.sv.manual.update.new.10.backoffice.create',
              'bonus.management.sv.manual.update.new.1.stockist.create',
              'bonus.management.sv.manual.update.new.2.stockist.create',
              'bonus.management.sv.manual.update.new.3.stockist.create',
              'bonus.management.sv.manual.update.new.4.stockist.create',
              'bonus.management.sv.manual.update.new.5.stockist.create',
              'bonus.management.sv.manual.update.new.6.stockist.create',
              'bonus.management.sv.manual.update.new.7.stockist.create',
              'bonus.management.sv.manual.update.new.8.stockist.create',
              'bonus.management.sv.manual.update.new.9.stockist.create',
              'bonus.management.sv.manual.update.new.10.stockist.create',
            ],
          },
        ],
      },
    ],
  },
  giroTypes: {
    list: [],
  },
  selectedFilters: Object.assign(
    {
      countryID: null,
      countryCode: null,
      countryName: null,
      filterTerms: '',
      filterDateRangeFrom: '',
      filterDateRangeTo: '',
      filterChannel: null,
      filterDeliveryStatus: null,
      filterDeliveryMethods: null,
      filterOrderStatus: null,
      filterActivationStatus: null,
      filterRedemptionStatus: null,
      filterDeliveryStage: null,
      filterIcVerifiedStatus: 2,
      filterUserID: '',
      fromCreatedAt: null,
      toCreatedAt: null,
      filterMixedFilters: null,
      timestamp: '',
    },
    JSON.parse(localStorage.getItem(FILTER_DATA))
  ),
  stockLocations: {
    list: [],
  },
  locationTypes: {
    list: [],
  },
  accessTokens: [],
  additional_requirements: [],
  isUpdateAvailable: false,
  queue: {
    response: {
      closable: false,
      job_id: null,
      job_event_name: '',
      message: 'Your Request Has Been Started.Please Be patience ..',
      file: false,
    },
  },
  userValidation: {},
  externalAPIs: {
    classicVerification: {},
    classicCrossSponsoringVerification: {},
  },
  reports: {
    data: [],
  },
  area: {
    name: 'dashboard',
    data: 'default',
  },
  builder: {
    permissions: [],
  },
  standardMenu: {
    routes: [],
  },
  isErrorOccurred: localStorage.getItem(ERROR) || false,
  routes: {
    data: [],
  },
  settingsConfig: {},
  stockistStateAndCities: {},
  listItems: [],
  isLoading: false,
  roundingCalculation: {},
  paymentMethods: {
    data: {
      options: [],
    },
  },
}

export default {
  state,
  actions,
  mutations,
  getters,
}
